import { Component, OnInit, ViewChild } from '@angular/core';
import { Item } from '../../models/item';
import { Router } from '@angular/router';
import { ItemService } from '../../services/item.service';
import { UserService } from '../../../../services/user.service';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ItemType } from '../../models/item-type';
import { UserDto } from '../../../../models/user.model';
import { ItemTypeService } from '../../services/item-type.service';
import { TranslateService } from '@ngx-translate/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';

@Component({
  selector: 'app-user-status',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.css']
})
export class UserStatusComponent implements OnInit {
  
  displayedColumns = ['idUser','idItemType','from','till','duration', 'lastModification'];
  itemTypes:ItemType[];
  users:UserDto[];
  dataSource: MatTableDataSource<Item>;

  constructor(
    private itemService:ItemService,
    public userService:UserService,
    private itemTypeService:ItemTypeService,
    private translateService:TranslateService
  ) { }
  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  
  ngOnInit() {
    let allLabel = this.translateService.get('dropdown.all').subscribe(all=>{
      this.itemTypeService.GetAll().subscribe((data)=>{
        let types:ItemType[] = [{
          id:null,
          name:all
        }];
        if(data && data.payload){
          types.push(...(data.payload))
        }
        this.itemTypes = types;      
      });
      this.userService.getMembers().subscribe((data)=>{      
        if(data){
          let users:UserDto[] = [{
            id:null,
            fullName: all
          }];
          users.push(...data);
          this.users = users;   
        }
      })      
    });

    this.itemService.getStatus().subscribe(data=>{
      if(data){
        this.dataSource = new MatTableDataSource(data.payload);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;        
      }
    });
  }
  ngAfterViewInit() {

  }  
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }  
  getUserName(id:string){
    let ret:string = null;
    if(this.users){
      let user = this.users.find(u=>u.id == id);
      if(user){
        ret = user.fullName;
      }
    }
    return ret;
  }
  getTypeName(id:string){
    let ret:string = null;
    if(this.itemTypes){
      let type = this.itemTypes.find(t=>t.id == id);
      if(type){
        ret = type.name;
      }
    }
    return ret;
  }    
}
